import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "@material-tailwind/react";
import CloseCrossIcon from "assets/icons/closeCross.svg?react";
import React, { useState } from "react";
import { Button } from "../Buttons";
import t from "utils/i18n";

type ActionDialogProps = {
  open: boolean;
  type: "warning" | "success" | "error";
  heading: string;
  children: React.ReactNode;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  onClose: () => void;
  onConfirm: () => void;
  PrimarButtonText?: string;
  SecondaryButtonText?: string;
};

const ActionDialog = (props: ActionDialogProps) => {
  return (
    <Dialog
      {...({} as any)}
      open={props.open}
      size="sm"
      dismiss={{
        escapeKey: false,
        outsidePress: false,
      }}
      className="flex flex-col gap-4 p-8 pt-6 text-base rounded-[4px]"
      handler={() => alert("clicked")}
    >
      <DialogHeader
        {...({} as any)}
        className="flex items-center justify-between gap-1 p-0 text-xl"
      >
        <div className="flex items-center justify-center gap-1">
          {props.icon &&
            React.createElement(props.icon, {
              className: ``,
            })}
          <span>{props.heading}</span>
        </div>
        <Button variant={"Tertiary"} onClick={props.onClose}>
          <CloseCrossIcon />
        </Button>
      </DialogHeader>
      <DialogBody {...({} as any)} className="p-0 text-deep-blue">
        {props.children}
      </DialogBody>
      <DialogFooter {...({} as any)} className="flex gap-6 p-0">
        <Button
          variant="Secondary"
          size={"lg"}
          onClick={props.onClose}
          className="h-[44px]"
        >
          <span>
            {props.SecondaryButtonText ?? t("actionDialog.defaultNo")}
          </span>
        </Button>
        <Button size={"lg"} variant="Primary" onClick={props.onConfirm}>
          <span>{props.PrimarButtonText ?? t("actionDialog.defaultYes")}</span>
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export default ActionDialog;
